import React from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { auth } from "../helper/firebaseClient";
import { api } from "../utils/axios-instance";
import useAuth from "../stores/authStore";

/**
 * Shown INSTEAD of the app to signed-in members (anyone who is not the org
 * admin) when their organization's subscription has expired. Only the org
 * admin can pay, so there is nothing else for a member to do here except
 * contact them or log out. There is deliberately no navigation.
 *
 * It is a blocking screen rather than a redirect to /login: LoginPage sends a
 * signed-in user straight back to /dashboard, which would loop.
 */
const SubscriptionExpiredNotice = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const token = await auth.currentUser?.getIdToken();
      if (token) await api.put("/auth/logout/", { idToken: token });
    } catch (e) {
      // best effort: still sign the user out locally
    }
    try {
      await auth.signOut();
    } catch (e) {
      console.warn("Sign out failed", e);
    }
    secureLocalStorage.removeItem("profileData");
    secureLocalStorage.removeItem("token");
    useAuth.setState({ token: null, profileData: null });
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
        <h1 className="text-2xl font-bold text-[#111827]">
          Subscription expired
        </h1>
        <p className="mt-3 text-[15px] text-gray-600">
          Your organization's subscription has expired, so access is paused for
          everyone. Please ask your organization admin to renew it. You'll be
          able to continue as soon as it is renewed.
        </p>
        <button
          onClick={handleLogout}
          className="mt-6 rounded-lg bg-indigo-600 px-5 py-2 text-white hover:bg-indigo-700"
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default SubscriptionExpiredNotice;
